export enum QualificationFormField {
  QualificationType = "qualificationName",
  LicensingClasses = "licensingClasses",
  OtherQualificationType = "otherQualificationType",
  QualificationNumber = "qualificationNumber",
}
